import { AppErrorBoundary } from 'app-pages/error/AppErrorBoundary';
import SessionErrorPage from 'app-pages/pages/account/SessionErrorPage';
import TransperfectLanguageSelector from 'components/_temp_ui_common/Integrations/TransperfectLanguageSelector';
import { AgreementCheck } from 'components/agreement/AgreementCheck';
import { AuthProviderWithRedirectCallback, ProtectedRoute } from 'components/auth0/AuthProvider';
import { IdleWarningModal } from 'components/idle-warning-modal/IdleWarningModal';
import { InternationalizationProvider } from 'components/intl/InternationalizationProvider';
import { ChatProvider } from 'contexts/ChatContext';
import { CurrentUserProvider } from 'contexts/CurrentUserContext';
import { SponsorsProvider } from 'contexts/SponsorsContext';
import { Route, Routes } from 'react-router-dom';

import ErrorPage from 'app-pages/error/ErrorPage';
import AcceptInviteSuccessPage from 'app-pages/pages/account/AcceptInviteSuccessPage';
import { DevelopmentPage } from 'app-pages/pages/development/DevelopmentPage';

import { lazy } from 'react';
import { FeatureFlags, useFlag } from './hooks/useFlag';
import { MemberPrivateRouter } from './MemberPrivateRouter';

const AcceptInvitePage = lazy(() => import('app-pages/pages/account/AcceptInvitePage'));
const TestStylesPage = lazy(() => import('app-pages/pages/StylesTestPage'));
const MarketingLinks = lazy(() => import('app-pages/pages/MarketingLinks'));

export function MemberRouter() {
  const transperfectLanguageSelectorEnabled = useFlag(FeatureFlags.TransperfectLanguageSelectorEnabled);

  const requireSession = AUTH_BYPASS && global.location.pathname === '/login' ? false : true;

  return (
    <Routes>
      {/**
       * Unauthenticated routes will be siblings to this wildcard route
       */}
      <Route path="/session-error" element={<SessionErrorPage />} />

      <Route
        path="/*"
        element={
          <AuthProviderWithRedirectCallback>
            {transperfectLanguageSelectorEnabled && <TransperfectLanguageSelector />}
            <AppErrorBoundary>
              <InternationalizationProvider>
                <CurrentUserProvider requiresSession={requireSession}>
                  <SponsorsProvider>
                    <ChatProvider>
                      <AgreementCheck>
                        <Routes>
                          {AUTH_BYPASS && <Route path="/login" element={<DevelopmentPage />} />}
                          {REACT_APP_STAGE !== 'production' && <Route path="/test" element={<TestStylesPage />} />}
                          {REACT_APP_STAGE !== 'production' && <Route path="/marketing" element={<MarketingLinks />} />}
                          <Route path="error" element={<ErrorPage />} />
                          <Route path="/accept-invite" element={<AcceptInvitePage />} />
                          <Route path="/accept-invite/success" element={<AcceptInviteSuccessPage />} />

                          <Route path="*" element={<ProtectedRoute component={MemberPrivateRouter} />} />
                        </Routes>

                        <IdleWarningModal />
                      </AgreementCheck>
                    </ChatProvider>
                  </SponsorsProvider>
                </CurrentUserProvider>
              </InternationalizationProvider>
            </AppErrorBoundary>
          </AuthProviderWithRedirectCallback>
        }
      />
    </Routes>
  );
}
